import { NAME_VALUE_TYPE } from "../../shared/types/shared-types";

export const adjustmentTypesForUI = [
    { name: 'InsuranceAdjustment', value: 1 },
    { name: 'DiscountAdjustment', value: 2 },
    { name: 'DismissAndTotalWriteOff', value: 3 },
    { name: 'DismissAndRefund', value: 4 },
    { name: 'ChangeTreatmentFee', value: 5 },
    { name: 'OtherAdjustment', value: 7 },
    { name: 'AdditionalCharges', value: 9 },
    { name: 'Transfer', value: 14 },
];

export const insuranceAdjustmentTypes = [
    { name: 'InsuranceAdjustment', value: 1 },
    { name: 'Transfer', value: 14 },
];

export const applyTypes = {
    top: "Top",
    bottom: "Bootom",
    recalculate: "Recalculate"
}

export const paymentFrequency = {
    monthly: 'Monthly',
    quarterly: "Quarterly",
    semiAnnually: "Semi-Annually",
    annually: "Annually"
}

export const adjustmentTypes = {
    insuranceAdjustment: 1,
    discountAdjustment: 2,
    dismissAndTotalWriteOff: 3,
    dismissAndRefund: 4,
    changeTreatmentFee: 5,
    dueDateAdjustment: 6,
    otherAdjustment: 7,
    additionalCharges: 9,
    dueAmountAdjustment: 13,
    transfer: 14
};

export const adjustmentSubTypes = [
    { name: 'Patient Benefit Increased', value: 1, type:  'Credit'},
    { name: 'Patient Benefit Decreased', value: 2, type:  'Debit'},
    { name: 'Referral Discount', value: 3, type:  'Credit'},
    { name: 'Courtsey Discount', value: 4, type:  'Credit'},
    { name: 'Other Discount', value: 5, type:  'Credit'},
    { name: 'Dismiss and Total Write Off', value: 6, type:  'Credit'},
    { name: 'Dismiss and Refund', value: 7, type:  'Credit'},
    { name: 'Treatment Fee Decreased', value: 8, type:  'Credit'},
    { name: 'Treatment Fee Increased', value: 9, type:  'Debit'},
    { name: 'Due Date Adjustment', value: 10, type: 'NoEffect'},
    { name: 'Other Adjustment', value: 11, type: 'Credit'},
    { name: 'Rewrite Adjustment', value: 12, type: 'Credit'},
    { name: 'Late Fee', value: 13, type: 'Debit'},
    { name: 'Additional Charges', value: 14, type: 'Debit'},
    { name: 'Transfer To', value: 15, type: 'Credit'}
];

export const creditorDebitor = {
    credit: 'Credit',
    debit: 'Debit'
}

export const adjustmentMessage = {
    adjustmentSuccess:  "Adjustment applied successfully.",
    dueAmountUpdatedSuccess:  "Due amount updated successfully.",
    dueDayUpdatedSuccess:  "Due day updated successfully.",
    invoiceUpdatedSuccess:  "Invoice updated successfully.",
    dueAmountValidation:  "The due amount should be greater than"
}

export const filingModes: NAME_VALUE_TYPE[] = [
    { name: 'Automatic', value: 'Automatic' },
    { name: 'Manual', value: 'Manual' }
];

export const days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]

export const mergeType = {
   above: "above",
   below: "below",
   last: "last",
   writeOff: "writeoff",
   dueDate: "duedate",
   reorder: "reorder"
}

export const amountValidation = {
    dueAmount : 10
}

export const adjustmentType = {
    transfer: 'Transfer'
}